const home = {
  intro: 'Carbonlite is a leading supplier of reel to reel narrow web coating, laminating and UV embossing machines.',
}

export default home